export class CuotasDiferidas {
  constructor(
    public fechaCuota: string,
    public valorCuota: number,
    public concepto: string
  ) {
  }
}
